import React from "react";
import YouTube from "react-youtube";

const FilmArchiveTV = ({ videoId }) => {
  const opts = {
    width: "100%",
    height: "100%",
    playerVars: {
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <div className="tv-video-zoom">
      <YouTube videoId={videoId} opts={opts} />
    </div>
  );
};

export default FilmArchiveTV;
